import redirectionConfig from './config.json';

export function hasLocaleVersion(path, locale) {
  const supportedLocales = redirectionConfig[path] || redirectionConfig[`${path}/`];

  if (!supportedLocales || !locale || locale === 'en') {
    return false;
  }

  return supportedLocales.indexOf(locale) !== -1;
}

export function getClientLocale() {
  /* eslint-env browser */
  const locale = window.__locale; // eslint-disable-line no-underscore-dangle
  return standardizeLocale(locale);
}

export function getServerLocale(locals) {
  const locale = locals.locale;
  return standardizeLocale(locale);
}

function standardizeLocale(locale) {
  switch (locale) {
    case 'ja':
      return 'jp';
    default:
      return locale;
  }
}



// WEBPACK FOOTER //
// ./src/modules/locale-redirection/utils.js